import * as React from "react";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";
import { IFilter } from "../../stores/filterStore";
import { AppProps } from "../../stores/storeContract";
import soundLogo from "../../assets/images/Sound.png";
import telegramLogo from "../../assets/images/Telegram.png";
import browserLogo from "../../assets/images/Browser.png";
import apiLogo from "../../assets/images/Api.png";
import "./FilterItem.scss";
import FilterItemModal from "./FilterItemModal";

interface AppPropsFilterItem extends AppProps {  
  filter?: IFilter,
  filterIndex?: number,
  isOpen?: boolean
}

@inject("filterStore", "symbolStore", "formatStore", "settingsStore")
@observer
export default class FilterItem extends React.Component<AppPropsFilterItem> {

    @computed get intervalsSummary(): string {
      	return this.props.formatStore.formatIntervals(this.props.filter.intervals);
    }

    @computed get symbolsSummary(): string {
		var symbolNameDetails = this.props.symbolStore.symbolNameDetails;
		var symbols = this.props.filter.symbols;

		var filteredSymbolNameDetails = symbolNameDetails.filter(snd => symbols.includes(snd.symbol));

		if (filteredSymbolNameDetails.length == 0) {
			return 'No pair selected';
		}

		if (filteredSymbolNameDetails.length < 4) {
			return filteredSymbolNameDetails.map(snd => snd.pair).join(', ');
		}

		var group = filteredSymbolNameDetails[0].quoteLong;
		var hasSingleGroupOnly = filteredSymbolNameDetails.every(snd => snd.quoteLong == group);

		if (!hasSingleGroupOnly)
		{
			return filteredSymbolNameDetails.length + ' pairs';
		}

		return filteredSymbolNameDetails.length + ' ' + group + ' pairs';
    }

	@computed get volumeSummary() {
		if (this.props.filter.volumeType == 0)
			return '';

		var type = this.props.filter.volumeType == 1 ? 'Interval' : '24h';
		return 'Volume: '+  type + ', ' + this.props.filter.volume + ' ' + this.props.settingsStore.defaultQuote;
	}
  
    render() {

		const { filter, filterIndex, isOpen } = this.props;
		const { setOpenId } = this.props.filterStore;
		const { telegramEnabled, apiEnabled } = this.props.settingsStore;

		return (
      		<div className="filter-item" style={{borderLeft: filter.color}} id={filter.id.toString()}>
				{
					isOpen ? (
						<FilterItemModal {...this.props}></FilterItemModal>
						
					) : (
						<div className="filter-item-closed" onClick={() => setOpenId(filter.id)}>							
							<span className="filter-item-label"> Filter #{filterIndex}</span>
							<span className="float-right">
								<img src={soundLogo} 
									alt="Sound" 
									className={filter.soundIndex > 0 ? 'filter-item-icon-active' : 'filter-item-icon'} />
								<img src={browserLogo} 
									alt="Browser" 
									className={filter.browserNotifications ? 'filter-item-icon-active' : 'filter-item-icon'} />
								<img src={telegramLogo} 
									alt="Telegram" 
									className={telegramEnabled ? (filter.telegramNotifications ? 'filter-item-icon-active' : 'filter-item-icon') : 'hidden'} />								
								<img src={apiLogo} 
									alt="Api" 
									className={apiEnabled ? (filter.apiNotifications ? 'filter-item-icon-active' : 'filter-item-icon') : 'hidden'} />
							</span>
							<div>{this.symbolsSummary}</div>
							<div>Intervals: {this.intervalsSummary}</div>
							<div>Price: {filter.priceChangeDirection == 0 ? 'More than' : 'Less than'} {filter.priceChangePercentage}%</div>
							<div>{this.volumeSummary}</div>
						</div>
					)
				}
			</div>
    	);
  	}
}